<footer id="footer" class="footer text-center">
    <p>Website created by <code>SpringIntoJava</code> &copy; 2026
    </p>
    <p><a href="mailto:aliza.shanet@gmail.com">Email us for website-related comments and technical support</a> </p>
</footer>